import ReactDOM from 'react-dom/client';
import { render } from 'react-dom'

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';
// import { store, persistor } from './redux/store';
import { store, persistor } from "./redux/store"
//
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
// import { PersistGate } from 'reduxjs-toolkit-persist/integration/react';


const rootElement = document.getElementById('root')


render(
    <HelmetProvider>
        <BrowserRouter>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <App />
                </PersistGate>
            </Provider>
        </BrowserRouter>
    </HelmetProvider>,
    rootElement
);

serviceWorker.unregister();

reportWebVitals();
